import {Component, OnDestroy, OnInit, Input, ViewChild, AfterViewInit, OnChanges, SimpleChanges} from '@angular/core';
import { ValidateService } from 'src/app/modules/product/services/validate.service';
import { DataService } from '../../services/data.service';
import { EventManager } from 'src/app/core';
import { Subscription } from 'rxjs';
import { Constant } from 'src/app/core/constant';
import { Fee } from '../../models/fee.model';
import { AppQueries } from 'src/app/state';
import { FilterStartEndDateComponent } from 'src/app/shared/components/filter-start-end-date/filter-start-end-date';
import { NumberUtil } from '../../../../shared/util/number.util';
declare let $: any;
@Component({
  selector: 'app-edit-fee',
  templateUrl: './edit-fee.component.html',
  styleUrls: ['./edit-fee.component.scss'],
  providers: [ValidateService, DataService],
})
export class EditFeeComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @ViewChild("filterStartEndDate", { static: true }) filterStartEndDateComponent: FilterStartEndDateComponent;
  @Input() relationalOperators: any[] = [];
  @Input() boardcast: string;
  @Input() unit: string;
  @Input() unitValue: string = 'MONEY'; //'MONTH';
  @Input() isUnitConfig: boolean = false;
  @Input() isUnitConfigByDay: boolean = false;
  @Input() isNoUnitConfigByMoney: boolean = false;
  @Input() feeList: any[];
  @Input() isHasDate: boolean = false;
  @Input() isViewed: boolean = false;
  @Input() isValidated: boolean = false;
  @Input() typeCode: string;
  Constant = Constant;
  fee: any = {};
  lastedFee: any = {};
  beginOperators: any = [] = [];
  endOperators: any = [] = [];
  fees: any[];
  unitValues: any[] = [];
  subscribe: Subscription;
  id: any;
  fromDate = null;
  toDate = null;
  note: string = '';
  constructor(
    public validateService: ValidateService,
    private eventManager: EventManager,
    private appQueries: AppQueries,
  ) {
  }
  ngOnInit() {
    this.id = Math.floor(Math.random() * 10000);
    this.setDefaultFee();
    this.subscribe = this.eventManager.subscribe(this.boardcast + '-emit' , (content) => {
      this.emitData();
    });
    if (this.feeList.length > 0) {
      this.setDataEditForFee();
    }
    this.appQueries.resources$
    .subscribe((resources) => {
      this.unitValues = ((resources || {}).dataUnitFee || []).slice();
      if (this.isNoUnitConfigByMoney) {
        const index = this.unitValues.findIndex(item => item.code === 'MONEY');
        this.unitValues.splice(index, 1);
      } 
      this.changeUnit();
    });
  }
  ngOnDestroy() {
    this.subscribe.unsubscribe();
  }
  setDefaultFee() {
    this.beginOperators = this.beginOperators || [];
    this.endOperators = this.endOperators || [];
    this.fee = {
      beginValue: undefined,
      endValue: undefined,
      fee: undefined,
      beginOperatorCode: '>=',
      endOperatorCode : '<',
    } ;
    this.lastedFee = {
      beginValue: undefined,
      endValue: undefined,
      fee: undefined,
      beginOperatorCode: '>=',
      endOperatorCode : '<',
      lasted: true
    };
    this.fees = [];
    this.setUpDataBeforeFeeForAfterFee();
  }
  ngAfterViewInit() {
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.relationalOperators && changes.relationalOperators.currentValue && changes.relationalOperators.currentValue.length > 0) {
      this.setRelationalOperators();
    }
    if (changes.feeList && changes.feeList.currentValue) {
      if (changes.feeList.currentValue.length > 0) {
        this.setDataEditForFee();
      } else {
        this.setDefaultFee();
      }
      if (this.isUnitConfig) {
        this.checkUnit();
      }
    }
    if (changes.isUnitConfig && changes.isUnitConfig.currentValue) {
      this.checkUnit();
    }
  }
  checkUnit() {
    const feeList = this.feeList || [];
    if (feeList.length > 0) {
      const fee = feeList[0];
      this.unitValue = fee.feeUnitCode || 'MONTH';
    }
    this.changeUnit();
  }
  setDataEditForFee() {
    this.fees = [];
    if (!(this.feeList && this.feeList.length > 0)) {
      return;
    }
    this.feeList.forEach((item, index) => {
      const fee = new Fee(item);
      fee.typeCode = this.typeCode;
      if (index === this.feeList.length - 1){ 
        item.endValue = null;
      };
      item.schemeId = (item.schemeId || {}).id || item.schemeId;
      this.fees.push(fee);
    });
    if (this.fees.length > 1) {
      this.fee = this.fees.shift();
      this.lastedFee = this.fees.pop();
    }
    if (!this.lastedFee) {
      this.lastedFee  = {};
      this.lastedFee.beginValue = this.fee.endValue;
    }
    this.lastedFee.lasted = true;
    if (this.fee.fromDate) {
      this.fromDate = new Date( this.fee.fromDate);
    }
    if (this.fee.toDate) {
      this.toDate = new Date( this.fee.toDate);
    }
    this.note = this.fee.note;
  }
  setRelationalOperators() {
    this.beginOperators = [];
    this.endOperators = [];
    this.relationalOperators.forEach((operator) => {
      switch (operator.name) {
        case '<=':
        operator.reverseOperator = '>=';
        break;
        case '<':
        operator.reverseOperator = '>';
        break;
        case '>=':
        operator.reverseOperator = '<=';
        break;
        case '>':
        operator.reverseOperator = '<';
        break;
      }
      if (operator.direction === 0) {
        this.beginOperators.push(operator);
      } else {
        this.endOperators.push(operator);
      }
    });
  }
  
  addFee() {
    this.fees = this.fees || [];
    const newFee = new Fee();
    newFee.typeCode = this.typeCode;
    this.fees.push(newFee);
    let fee = null;
    let operator = null;
    if (this.fees.length > 1) {
      fee = this.fees[this.fees.length  -  1];
      fee.beginValue = this.fees[this.fees.length  -  2].endValue;
      operator = this.relationalOperators.find((ope) => ope.code === this.fees[this.fees.length  -  2].endOperatorCode);
    } else {
      fee = this.fees[0];
      fee.beginValue = this.fee.endValue;
      operator = this.relationalOperators.find((ope) => ope.code === this.fee.endOperatorCode);
    }
    fee.beginOperatorCode = operator ? operator.symmetry.code : fee.beginOperatorCode;
    operator = this.relationalOperators.find((ope) => ope.code ===  this.lastedFee.beginOperatorCode);
    fee.endOperatorCode = operator ? operator.symmetry.code : fee.endOperatorCode;
    this.lastedFee.beginValue = '';
  }
  removeFee(index) {
    this.fees.splice(index, 1);
    this.setUpDataBeforeFeeForAfterFee();
  }
  setUpDataBeforeFeeForAfterFee() {
    this.relationalOperators = this.relationalOperators || [];
    const fees = [...[this.fee], ...this.fees, ...[this.lastedFee]];
    for (let i = 0; i < fees.length; i++) {
      const fee = fees[i];
      const afterFee = fees[i + 1];
      if (!afterFee) {
        const operator = this.relationalOperators.find((ope) =>  ope.code === fee.beginOperatorCode);
        if (!operator) {
          return;
        }
        fee.endOperatorCode = operator.symmetry.code;
        return;
      }
      afterFee.beginValue = fee.endValue;
      const operator = this.relationalOperators.find((ope) =>  ope.code === fee.endOperatorCode);
      if (!operator) {
        return;
      }
      afterFee.beginOperatorCode = operator.symmetry.code;
    }
  }
  changeOperator(index, isStart?) {
    this.relationalOperators = this.relationalOperators || [];
    if (index || index === 0) {
      if (this.fees.length  > index  +  1 ) {
        const operator = this.relationalOperators.find((ope) => ope.code ===  this.fees[index].endOperatorCode);
        this.fees[index  +  1].beginOperatorCode = operator.symmetry.code;
      } else {
        const operator = this.relationalOperators.find((ope) => ope.code ===  this.fees[index].endOperatorCode);
        this.lastedFee.beginOperatorCode = operator.symmetry.code;
      }
    } else if (!isStart) {
      const operator = this.relationalOperators.find((ope) => ope.code ===  this.lastedFee.beginOperatorCode);
      if (this.fees.length > 0) {
        this.fees[this.fees.length  - 1].endOperatorCode = operator.symmetry.code;
      } else {
        this.fee.endOperatorCode = operator.symmetry.code;
      }
    } else if (isStart) {
      const operator = this.relationalOperators.find((ope) => ope.code ===  this.fee.endOperatorCode);
      if (this.fees.length === 0) {
        this.lastedFee.beginOperatorCode = operator.symmetry.code;
      } else {
        this.fees[0].beginOperatorCode = operator.symmetry.code;
      }
    }
  }
  changeValue(index?) {
    if (index || index === 0) {
      if (this.fees.length  > index  +  1 ) {
        this.fees[index  +  1].beginValue = this.fees[index].endValue;
      } else {
        this.lastedFee.beginValue = this.fees[this.fees.length  -  1].endValue;
      }
    } else {
      if (this.fees.length === 0) {
        this.lastedFee.beginValue = this.fee.endValue;
      } else {
        this.fees[0].beginValue = this.fee.endValue;
      }
    }
  }
  cookData() {
    if (!this.fee.beginOperatorCode && this.fee.endOperatorCode) {
      const findOperator = this.endOperators.find(ope => ope.code === this.fee.endOperatorCode);
      this.fee.beginOperatorCode = (findOperator || {}).reverseOperator;
    }
    if (!this.lastedFee.beginOperatorCode && this.lastedFee.endOperatorCode) {
      const findOperator = this.endOperators.find(ope => ope.code === this.lastedFee.endOperatorCode);
      this.lastedFee.beginOperatorCode = (findOperator || {}).reverseOperator;
    }
    if (this.fee.beginOperatorCode && !this.fee.endOperatorCode) {
      const findOperator = this.beginOperators.find(ope => ope.code === this.fee.beginOperatorCode);
      this.fee.endOperatorCode = (findOperator || {}).reverseOperator;
    }
    if (this.lastedFee.beginOperatorCode && !this.lastedFee.endOperatorCode) {
      const findOperator = this.beginOperators.find(ope => ope.code === this.lastedFee.beginOperatorCode);
      this.lastedFee.endOperatorCode = (findOperator || {}).reverseOperator;
    }
  }
  emitData() {
    this.cookData();
    let fees = [];
    this.fee.beginValue = this.fee.beginValue || 0;
    if (this.fee.endValue && this.fee.fee >= 0) {
      fees.push(this.fee);
    }
    let list = [];
    this.fees.forEach((fee, index) => {
      if (index < this.fees.length  -  1) {
        this.fees[index + 1].beginValue = fee.endValue;
      }
      if (index === 0) {
        this.fees[index].beginValue = this.fee.endValue;
      }
      if (fee.endValue && fee.fee >= 0) {
        list.push(fee);
      }
    });
    if (list.length > 0 ) {
      fees = fees.concat(list);
    } else {
      this.lastedFee.beginValue = this.fee.endValue;
    }
    if (this.lastedFee.beginValue && this.lastedFee.fee >= 0) {
      this.lastedFee.endValue = null;
      fees.push(this.lastedFee);
    }
    const { startDate, endDate } = this.filterStartEndDateComponent.emitData();
    fees = fees.map((fee) => {
      fee.beginOperatorCode = fee.beginOperatorCode || "";
      fee.endOperatorCode = fee.endOperatorCode || "";
      fee.fromDate = !this.isHasDate || !startDate ? undefined : startDate;
      fee.toDate = !this.isHasDate || !endDate ? undefined : endDate;
      fee.note = this.note;
      fee.feeUnitCode = this.unitValue || 'MONTH';
      fee.typeCode = this.typeCode;
      return fee;
    });
    this.eventManager.broadcast({
      name: this.boardcast + '-result',
      content: fees
    })
    return fees;
  }
  changeUnit() {
    if (this.isUnitConfigByDay) {
      this.unitValue = 'DAY';
    }
    const unit = this.unitValues.find(item => item.code === this.unitValue) || {};
    this.unit = unit.name || '';
  }
}
